import { render, staticRenderFns } from "./ISAMigrationBanner.vue?vue&type=template&id=42f2333a&scoped=true&"
import script from "./ISAMigrationBanner.vue?vue&type=script&lang=js&"
export * from "./ISAMigrationBanner.vue?vue&type=script&lang=js&"
import style0 from "./ISAMigrationBanner.vue?vue&type=style&index=0&id=42f2333a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f2333a",
  null
  
)

export default component.exports